export default "__VITE_ASSET__Wbd_06UL__"